module.exports = __webpack_public_path__ + "img/epixeiriseis ekptoseis.15911aa6.jpg";